import { ComponentProps } from 'react';

import Title from '../Title';

type TitleVariant = ComponentProps<typeof Title>['variant'];
type TextSize = ComponentProps<typeof Title>['size'];

const calculateSize = (variant: TitleVariant, size?: TextSize): TextSize => {
    if (size) {
        return size;
    }

    if (variant === 'page') {
        return 'xlarge';
    }

    if (variant === 'area') {
        return 'large';
    }

    return 'default';
};

export default calculateSize;
